package org.zq.astrock_ai.theme

import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp

object BinanceColors {
    val Dark = Color(0xFF0B0E11)
    val Card = Color(0xFF1E2329)
    val Elevated = Color(0xFF2B3139)
    val Yellow = Color(0xFFFCD535)
    val YellowActive = Color(0xFFF0B90B)
    val Green = Color(0xFF2EE59D)
    val Red = Color(0xFFFF6B7A)
    val Muted = Color(0xFFB4BCC8)
    val Body = Color(0xFFF5F6F7)
    val Hairline = Color(0xFF3D4550)
    val Info = Color(0xFF5B9FFF)
    val DarkText = Color(0xFF181A20)
}

private val BinanceDarkScheme = darkColorScheme(
    primary = BinanceColors.Yellow,
    onPrimary = BinanceColors.DarkText,
    secondary = BinanceColors.Green,
    background = BinanceColors.Dark,
    surface = BinanceColors.Card,
    onBackground = BinanceColors.Body,
    onSurface = BinanceColors.Body,
    outline = BinanceColors.Hairline,
)

@Composable
fun BinanceTheme(content: @Composable () -> Unit) {
    val fontFamily = rememberAppFontFamily()
    val typography = appTypography(
        fontFamily = fontFamily,
        base = androidx.compose.material3.Typography(
            bodyLarge = TextStyle(
                fontFamily = fontFamily,
                fontWeight = FontWeight.Normal,
                fontSize = 15.sp,
                lineHeight = 22.sp,
                color = BinanceColors.Body,
            ),
            bodyMedium = TextStyle(
                fontFamily = fontFamily,
                fontWeight = FontWeight.Normal,
                fontSize = 14.sp,
                lineHeight = 20.sp,
                color = BinanceColors.Body,
            ),
            bodySmall = TextStyle(
                fontFamily = fontFamily,
                fontWeight = FontWeight.Normal,
                fontSize = 13.sp,
                lineHeight = 18.sp,
                color = BinanceColors.Muted,
            ),
            labelSmall = TextStyle(
                fontFamily = fontFamily,
                fontWeight = FontWeight.Normal,
                fontSize = 12.sp,
                color = BinanceColors.Muted,
            ),
            titleMedium = TextStyle(
                fontFamily = fontFamily,
                fontWeight = FontWeight.SemiBold,
                fontSize = 15.sp,
                lineHeight = 22.sp,
                color = BinanceColors.Body,
            ),
        ),
    )
    MaterialTheme(
        colorScheme = BinanceDarkScheme,
        typography = typography,
        content = {
            CompositionLocalProvider(
                LocalContentColor provides BinanceColors.Body,
                LocalTextStyle provides TextStyle(
                    fontFamily = fontFamily,
                    color = BinanceColors.Body,
                    fontSize = 14.sp,
                ),
                LocalAppFontFamily provides fontFamily,
            ) {
                content()
            }
        },
    )
}
